<div *ngIf="this.viewSession === 3">
    <div class="basicrow f-reg f-black m-top-i text-justify">
        La contrase&ntilde;a de acceso es la clave con la que podr&aacute; acceder a manejar su cuenta de servicios en Claro.
    </div>

    <div class="basicrow m-top-i">
        <label class="label-f" id="pswd_info">Contrase&ntilde;a</label>

        <div class="basicrow">
            <input id="idClaveRegistro1" class="inp-f" maxlength="15" type="password" (keyup)="onKey($event)"  [(ngModel)]="this.passwd">
            <app-password-validator (validatePassword)="validatePassword=$event" ></app-password-validator>
        </div>
    </div>

    <div class="basicrow m-top-i">
        <label class="label-f" id="pswd_confirm">Confirmar contrase&ntilde;a</label>

        <div class="basicrow">
            <input id="pswdRecoveryConfirm" class="inp-f" maxlength="15" type="password" [(ngModel)]="this.pswdOk">
        </div>
    </div>


    <div class="basicrow m-top-i">
        <!-- <a (click)="this.submitForm(3);" class="btns gray vcenter" [ngClass]="{'red': this.validatePassword() && (this.passwd.localeCompare(vm.pswdOk) === 0)}"> -->
        <a (click)="this.submitForm(3);" class="btns gray vcenter red" >
            <span class="tabcell">
                Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>